import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersByIdParams, GetVouchersByIdResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";

import axios from "axios";

export const getVouchersById = createAsyncThunk<
  GetVouchersByIdResponse,
  GetVouchersByIdParams
>(
  `vouchers/getVouchersById`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersById({ voucherId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers by ID",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers by ID", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
